// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BetaToggle_container__8x65k {
  width: 100%;
  height: 100%;
}

.BetaToggle_title__JG139 {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--dark-color);
  text-align: center;
  letter-spacing: 0.5px;
  padding-bottom: 24px;
  border-bottom: 2px solid #e9ecef;
}

.BetaToggle_content__eyRyp {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.BetaToggle_applyButtonContainer__Y3KYi {
  text-align: right;
}

.BetaToggle_applyButton__dMH5x {
  padding: 10px 20px;
  background-color: var(--saveBtn);
  color: var(--white-color);
  font-size: 1rem;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.BetaToggle_applyButton__dMH5x:hover {
  background-color: var(--saveHover);
}

.BetaToggle_toggles__nOrTZ {
  display: flex;
  flex-direction: row;
  gap: 30px;
}

.BetaToggle_column__0Myj\\+ {
  flex: 1 1;
}

.BetaToggle_betatoggles-cards__G7S\\+G {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.BetaToggle_betatoggleBox__T\\+SL1 {
  position: relative;
  background: var(--white-color);
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 16px;
  box-shadow: var(--shadow-md);
  transition: border-color 0.2s ease;
}

.BetaToggle_description__qNT8S {
  margin: 6px 0;
  font-size: 0.95rem;
  color: #444;
}

.BetaToggle_toggleButton__I4IEv {
  padding: 6px 16px;
  background-color: #2563eb;
  color: white;
  font-size: 0.9rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.BetaToggle_toggleButton__I4IEv:hover {
  background-color: #1850ca;
}

.BetaToggle_toggleButton__I4IEv:disabled {
  background-color: #bac3ce;
  cursor: not-allowed;
  color: rgb(66, 66, 66);
}
.BetaToggle_keyLabel__n32J8 {
  font-weight: 500;
  color: #111827;
  margin-right: 4px;
  background-color: #f2f6ff;
  border: 1px solid #2563eb;
  padding: 8px 12px;
  border-radius: 8px;
  max-width: 75%;
  word-wrap: break-word;
  font-size: 16px;
}
.BetaToggle_enableStatus__ZiTcZ {
  font-weight: 500;
  border-right: 2px solid #2563eb;
  padding-right: 16px;
}
.BetaToggle_toggleText__VpCAI {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  color: #1f2937;
  padding: 15px;
  background: #e6edff;
  border-radius: 6px;
  border: 1px solid #a3bdff;
}
.BetaToggle_anotherStyle__L5mBn {
  position: absolute;
  top: 7%;
  right: 30px;
}

.BetaToggle_nestedSettings__7nlIK {
  margin-top: 18px;
  padding: 14px;
  background-color: #e6edff;
  border: 1px solid #a3bdff;
  border-radius: 6px;
}

.BetaToggle_subtitle__sF-Rd {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
  /* border-bottom: 1px solid #e5e7eb; */
  padding-bottom: 6px;
  text-align: left;
}

.BetaToggle_settingItem__oE5ty {
  margin-bottom: 14px;
  padding: 10px;
  border-radius: 6px;
  background: var(--white-color);
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: var(--shadow-md);
}

.BetaToggle_settingItem__oE5ty strong {
  color: #1f2937;
}

.BetaToggle_numericSetting__2Eqc0 {
  margin-top: 12px;
}

.BetaToggle_numericControl__o-rvC {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.BetaToggle_numericControl__o-rvC label {
  font-weight: 500;
  color: #374151;
  min-width: 100px;
}

.BetaToggle_numericInputGroup__t56Zh {
  display: flex;
  align-items: center;
  gap: 6px;
}

.BetaToggle_numericInputGroup__t56Zh input {
  width: 70px;
  padding: 6px;
  font-size: 0.9rem;
  text-align: center;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  background-color: #f9fafb;
  color: #111827;
}

.BetaToggle_numericInputGroup__t56Zh button {
  width: 30px;
  height: 30px;
  font-size: 1rem;
  font-weight: bold;
  background-color: #e5e7eb;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.BetaToggle_numericInputGroup__t56Zh button:hover {
  background-color: #d1d5db;
}
@media (max-width: 360px) {
  .BetaToggle_betatoggleBox__T\\+SL1 {
    padding: 0px;
    border: none;
  }
}
@media (max-width: 480px) {
  .BetaToggle_content__eyRyp {
    align-items: normal;
  }
  .BetaToggle_settingItem__oE5ty strong {
    display: block;
    margin-bottom: 10px;
    /* max-width: 55%;
    min-width: 100px; */
  }
  .BetaToggle_description__qNT8S {
    text-align: left;
    font-size: 0.85rem;
    line-height: 1.4;
  }
  .BetaToggle_toggleButton__I4IEv {
    width: 100%;
    max-width: 100px;
    font-size: 0.85rem;
    padding: 10px;
  }

  .BetaToggle_betatoggleBox__T\\+SL1 {
    padding: 0px;
    display: flex;
    flex-direction: column;
    border: none;
  }

  .BetaToggle_numericInputGroup__t56Zh {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }

  .BetaToggle_numericInputGroup__t56Zh input,
  .BetaToggle_numericInputGroup__t56Zh button {
    width: 100%;
  }
  .BetaToggle_anotherStyle__L5mBn {
    align-self: flex-start;
  }
  .BetaToggle_container__8x65k {
    flex-direction: column;
    /* padding: 16px; */
  }
  .BetaToggle_title__JG139 {
    font-size: 1.4rem;
  }
  .BetaToggle_applyButton__dMH5x {
    width: 100%;
  }
  .BetaToggle_settingItem__oE5ty {
    flex-direction: column;
  }
  .BetaToggle_toggleText__VpCAI {
    text-align: left;
    flex-direction: column;
  }
  .BetaToggle_keyLabel__n32J8 {
    font-weight: 600;
    max-width: initial;
    border: none;
    background: transparent;
    padding: 0px;
    font-size: 14px;
  }
  .BetaToggle_enableStatus__ZiTcZ {
    padding-right: 0px;
    border-right: none;
  }
}

@media (max-width: 576px) {
}

@media (min-width: 769px) and (max-width: 992px) {
  .BetaToggle_toggles__nOrTZ {
    flex-direction: column;
    gap: 20px;
  }

  .BetaToggle_applyButtonContainer__Y3KYi {
    text-align: center;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }

  .BetaToggle_applyButton__dMH5x {
    width: 100%;
    max-width: 300px;
  }
  .BetaToggle_settingItem__oE5ty strong {
    display: block;
    margin-bottom: 20px;
    max-width: 55%;
    min-width: 100px;
  }
  .BetaToggle_anotherStyle__L5mBn {
    align-self: flex-start;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .BetaToggle_toggleText__VpCAI {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 12px;
  }

  .BetaToggle_anotherStyle__L5mBn {
    position: relative;
    top: auto;
    right: auto;
    margin-top: 10px;
    align-self: flex-end;
  }

  .BetaToggle_settingItem__oE5ty {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .BetaToggle_numericControl__o-rvC {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .BetaToggle_numericInputGroup__t56Zh input {
    width: 100%;
    max-width: 100px;
  }
  .BetaToggle_settingItem__oE5ty strong {
    display: block;
    margin-bottom: 20px;
    max-width: 55%;
    min-width: 100px;
  }
  .BetaToggle_anotherStyle__L5mBn {
    align-self: flex-start;
  }
}

@media (min-width: 993px) and (max-width: 1200px) {
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/BetaToggle/BetaToggle.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,mBAAmB;IACnB;uBACmB;EACrB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;;IAEE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;AACA;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;AACA","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n}\n\n.title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: var(--dark-color);\n  text-align: center;\n  letter-spacing: 0.5px;\n  padding-bottom: 24px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.applyButtonContainer {\n  text-align: right;\n}\n\n.applyButton {\n  padding: 10px 20px;\n  background-color: var(--saveBtn);\n  color: var(--white-color);\n  font-size: 1rem;\n  border-radius: 6px;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.applyButton:hover {\n  background-color: var(--saveHover);\n}\n\n.toggles {\n  display: flex;\n  flex-direction: row;\n  gap: 30px;\n}\n\n.column {\n  flex: 1;\n}\n\n.betatoggles-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.betatoggleBox {\n  position: relative;\n  background: var(--white-color);\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: var(--shadow-md);\n  transition: border-color 0.2s ease;\n}\n\n.description {\n  margin: 6px 0;\n  font-size: 0.95rem;\n  color: #444;\n}\n\n.toggleButton {\n  padding: 6px 16px;\n  background-color: #2563eb;\n  color: white;\n  font-size: 0.9rem;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.toggleButton:hover {\n  background-color: #1850ca;\n}\n\n.toggleButton:disabled {\n  background-color: #bac3ce;\n  cursor: not-allowed;\n  color: rgb(66, 66, 66);\n}\n.keyLabel {\n  font-weight: 500;\n  color: #111827;\n  margin-right: 4px;\n  background-color: #f2f6ff;\n  border: 1px solid #2563eb;\n  padding: 8px 12px;\n  border-radius: 8px;\n  max-width: 75%;\n  word-wrap: break-word;\n  font-size: 16px;\n}\n.enableStatus {\n  font-weight: 500;\n  border-right: 2px solid #2563eb;\n  padding-right: 16px;\n}\n.toggleText {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.95rem;\n  color: #1f2937;\n  padding: 15px;\n  background: #e6edff;\n  border-radius: 6px;\n  border: 1px solid #a3bdff;\n}\n.anotherStyle {\n  position: absolute;\n  top: 7%;\n  right: 30px;\n}\n\n.nestedSettings {\n  margin-top: 18px;\n  padding: 14px;\n  background-color: #e6edff;\n  border: 1px solid #a3bdff;\n  border-radius: 6px;\n}\n\n.subtitle {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 12px;\n  /* border-bottom: 1px solid #e5e7eb; */\n  padding-bottom: 6px;\n  text-align: left;\n}\n\n.settingItem {\n  margin-bottom: 14px;\n  padding: 10px;\n  border-radius: 6px;\n  background: var(--white-color);\n  border: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: var(--shadow-md);\n}\n\n.settingItem strong {\n  color: #1f2937;\n}\n\n.numericSetting {\n  margin-top: 12px;\n}\n\n.numericControl {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.numericControl label {\n  font-weight: 500;\n  color: #374151;\n  min-width: 100px;\n}\n\n.numericInputGroup {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.numericInputGroup input {\n  width: 70px;\n  padding: 6px;\n  font-size: 0.9rem;\n  text-align: center;\n  border: 1px solid #d1d5db;\n  border-radius: 5px;\n  background-color: #f9fafb;\n  color: #111827;\n}\n\n.numericInputGroup button {\n  width: 30px;\n  height: 30px;\n  font-size: 1rem;\n  font-weight: bold;\n  background-color: #e5e7eb;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.numericInputGroup button:hover {\n  background-color: #d1d5db;\n}\n@media (max-width: 360px) {\n  .betatoggleBox {\n    padding: 0px;\n    border: none;\n  }\n}\n@media (max-width: 480px) {\n  .content {\n    align-items: normal;\n  }\n  .settingItem strong {\n    display: block;\n    margin-bottom: 10px;\n    /* max-width: 55%;\n    min-width: 100px; */\n  }\n  .description {\n    text-align: left;\n    font-size: 0.85rem;\n    line-height: 1.4;\n  }\n  .toggleButton {\n    width: 100%;\n    max-width: 100px;\n    font-size: 0.85rem;\n    padding: 10px;\n  }\n\n  .betatoggleBox {\n    padding: 0px;\n    display: flex;\n    flex-direction: column;\n    border: none;\n  }\n\n  .numericInputGroup {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 4px;\n  }\n\n  .numericInputGroup input,\n  .numericInputGroup button {\n    width: 100%;\n  }\n  .anotherStyle {\n    align-self: flex-start;\n  }\n  .container {\n    flex-direction: column;\n    /* padding: 16px; */\n  }\n  .title {\n    font-size: 1.4rem;\n  }\n  .applyButton {\n    width: 100%;\n  }\n  .settingItem {\n    flex-direction: column;\n  }\n  .toggleText {\n    text-align: left;\n    flex-direction: column;\n  }\n  .keyLabel {\n    font-weight: 600;\n    max-width: initial;\n    border: none;\n    background: transparent;\n    padding: 0px;\n    font-size: 14px;\n  }\n  .enableStatus {\n    padding-right: 0px;\n    border-right: none;\n  }\n}\n\n@media (max-width: 576px) {\n}\n\n@media (min-width: 769px) and (max-width: 992px) {\n  .toggles {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .applyButtonContainer {\n    text-align: center;\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n  }\n\n  .applyButton {\n    width: 100%;\n    max-width: 300px;\n  }\n  .settingItem strong {\n    display: block;\n    margin-bottom: 20px;\n    max-width: 55%;\n    min-width: 100px;\n  }\n  .anotherStyle {\n    align-self: flex-start;\n  }\n}\n\n@media (min-width: 577px) and (max-width: 768px) {\n  .toggleText {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n    padding: 12px;\n  }\n\n  .anotherStyle {\n    position: relative;\n    top: auto;\n    right: auto;\n    margin-top: 10px;\n    align-self: flex-end;\n  }\n\n  .settingItem {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .numericControl {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n\n  .numericInputGroup input {\n    width: 100%;\n    max-width: 100px;\n  }\n  .settingItem strong {\n    display: block;\n    margin-bottom: 20px;\n    max-width: 55%;\n    min-width: 100px;\n  }\n  .anotherStyle {\n    align-self: flex-start;\n  }\n}\n\n@media (min-width: 993px) and (max-width: 1200px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BetaToggle_container__8x65k`,
	"title": `BetaToggle_title__JG139`,
	"content": `BetaToggle_content__eyRyp`,
	"applyButtonContainer": `BetaToggle_applyButtonContainer__Y3KYi`,
	"applyButton": `BetaToggle_applyButton__dMH5x`,
	"toggles": `BetaToggle_toggles__nOrTZ`,
	"column": `BetaToggle_column__0Myj+`,
	"betatoggles-cards": `BetaToggle_betatoggles-cards__G7S+G`,
	"betatoggleBox": `BetaToggle_betatoggleBox__T+SL1`,
	"description": `BetaToggle_description__qNT8S`,
	"toggleButton": `BetaToggle_toggleButton__I4IEv`,
	"keyLabel": `BetaToggle_keyLabel__n32J8`,
	"enableStatus": `BetaToggle_enableStatus__ZiTcZ`,
	"toggleText": `BetaToggle_toggleText__VpCAI`,
	"anotherStyle": `BetaToggle_anotherStyle__L5mBn`,
	"nestedSettings": `BetaToggle_nestedSettings__7nlIK`,
	"subtitle": `BetaToggle_subtitle__sF-Rd`,
	"settingItem": `BetaToggle_settingItem__oE5ty`,
	"numericSetting": `BetaToggle_numericSetting__2Eqc0`,
	"numericControl": `BetaToggle_numericControl__o-rvC`,
	"numericInputGroup": `BetaToggle_numericInputGroup__t56Zh`
};
export default ___CSS_LOADER_EXPORT___;
